import { reactive } from 'vue'

export type BuffCard = any

export const ACTIVITY_BUFF_SOURCES = {
  DREAM_GIRL: 'dreamGirlRank',
  KING: 'kingRank',
  ROOM: 'roomRank',
} as const

type BuffCardSource = (typeof ACTIVITY_BUFF_SOURCES)[keyof typeof ACTIVITY_BUFF_SOURCES]

type ActivityBuffState = Record<string, Record<BuffCardSource, BuffCard[]>>

const state = reactive<{ buffCardsByActivity: ActivityBuffState }>({
  buffCardsByActivity: {},
})

const ensureActivity = (activityCode: string) => {
  if (!state.buffCardsByActivity[activityCode]) {
    state.buffCardsByActivity[activityCode] = {
      dreamGirlRank: [],
      kingRank: [],
      roomRank: [],
    }
  }
  return state.buffCardsByActivity[activityCode]
}

export const setActivityBuffCards = (activityCode: string, source: BuffCardSource, cards: BuffCard[]) => {
  const activityState = ensureActivity(activityCode)
  activityState[source] = Array.isArray(cards) ? cards.slice() : []
}

export const getActivityBuffCards = (activityCode: string, source: BuffCardSource) => {
  const activityState = ensureActivity(activityCode)
  return activityState[source] || []
}

export const clearActivityBuffCards = (activityCode?: string, source?: BuffCardSource) => {
  if (!activityCode) {
    state.buffCardsByActivity = {}
    return
  }
  const activityState = ensureActivity(activityCode)
  if (source) {
    activityState[source] = []
    return
  }
  activityState.dreamGirlRank = []
  activityState.kingRank = []
  activityState.roomRank = []
}
